export default __webpack_public_path__ + "static/media/hungryMonsterImageThree.d1a5cfad.png";